import React from 'react';
import { Modal } from 'antd';
import SharingContent from './SharingContent';
import * as CONSTANT from '../constant';

const SharingModal = ({
  title,
  visible,
  url,
  id,
  isFetching,
  hide,
}) => (
  <Modal
    open={visible}
    title={CONSTANT.MODAL_TITLE}
    footer={null}
    onCancel={hide}
    maskClosable={false}
  >
    <SharingContent
      title={title}
      url={url}
      id={id}
      isFetching={isFetching}
      hide={hide}
      open={visible}
    />
  </Modal>
);

export default SharingModal;
